import { activeStyle, inactiveStyle } from 'components/SharedTable/styles'


export const GetComponentActiveInactive = ({ isActive }: { isActive: string }) => {
    return (
        <span
            className={
                /^true$/i.test(isActive) ? activeStyle : inactiveStyle
            }
        >
            {/^true$/i.test(isActive) ? 'Ativo' : 'Inativo'}
        </span>
    )
}